// extracted by mini-css-extract-plugin
export default {"slideContainer":"_814c0561b8 _4e8dc6bf7b _5768c29163","slideImage":"df6042d859"};